import * as React from "react";
import { Dropdown, Input } from "semantic-ui-react";
import PlayerCardField from "./Fields/PlayerCardField";
import CustomTitleField from "./Fields/CustomTitleField";
import DisplayFieldLabel from "./Fields/DisplayFieldLabel";
import { useFormContext, useWatch } from "react-hook-form";
import { PolymorphicPlayerCard } from "../../../../../services/bedrock";
import { useEffect } from "react";

interface AddressWidgetSettingsProps {
  index: number;
}

const AddressWidgetSettings: React.FC<AddressWidgetSettingsProps> = ({ index }) => {
  const [workTypeOptions, setWorkTypeOptions] = React.useState([
    { key: "Home", value: "Home", text: "Home" },
    { key: "Work", value: "Work", text: "Work" },
    { key: "School", value: "School", text: "School" },
  ]);

  const { control } = useFormContext<PolymorphicPlayerCard>();
  const watchedType = useWatch({ control, name: `widgets.${index}.owner.addressType` });

  useEffect(() => {
    if (!watchedType) return;
    setWorkTypeOptions(prev => {
      if (prev.some(o => o.value === watchedType)) {
        return prev;
      } else {
        return [...prev, { key: watchedType, value: watchedType, text: watchedType }];
      }
    });
  }, [watchedType]);

  const states = [
    "AL",
    "AK",
    "AZ",
    "AR",
    "CA",
    "CO",
    "CT",
    "DE",
    "DC",
    "FL",
    "GA",
    "HI",
    "ID",
    "IL",
    "IN",
    "IA",
    "KS",
    "KY",
    "LA",
    "ME",
    "MD",
    "MA",
    "MI",
    "MN",
    "MS",
    "MO",
    "MT",
    "NE",
    "NV",
    "NH",
    "NJ",
    "NM",
    "NY",
    "NC",
    "ND",
    "OH",
    "OK",
    "OR",
    "PA",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VT",
    "VA",
    "WA",
    "WV",
    "WI",
    "WY",
  ];
  const stateOptions = states.map(state => ({ key: state, value: state, text: state }));

  return (
    <div className="playerCardWidgetOwner playerCardAddress">
      <div className="playerCardInputsRow">
        <PlayerCardField
          index={index}
          fieldName="streetLine1"
          rules={{
            required: "This is required.",
          }}
          component={Input}
          fieldLabel="Street Line 1"
          placeholder="Street Line 1"
          autoComplete="address-line1"
        />
        <PlayerCardField
          index={index}
          fieldName="streetLine2"
          component={Input}
          fieldLabel="Street Line 2"
          placeholder="Street Line 2"
          autoComplete="address-line2"
        />
      </div>
      <div className="playerCardInputsRow">
        <PlayerCardField
          index={index}
          fieldName="city"
          rules={{
            required: "This is required.",
          }}
          component={Input}
          fieldLabel="City"
          placeholder="City"
          autoComplete="address-level2"
        />
        <PlayerCardField
          index={index}
          fieldName="state"
          rules={{
            required: "This is required.",
          }}
          component={Dropdown}
          selection
          search
          fieldLabel="State"
          placeholder="State"
          autoComplete="address-level1"
          options={stateOptions}
        />
      </div>
      <div className="playerCardInputsRow">
        <PlayerCardField
          index={index}
          fieldName="zip"
          rules={{
            required: "This is required.",
          }}
          component={Input}
          fieldLabel="ZIP"
          placeholder="ZIP"
          autoComplete="postal-code"
        />
        <PlayerCardField
          index={index}
          fieldName="addressType"
          component={Dropdown}
          autoComplete="off"
          fieldLabel={<DisplayFieldLabel index={index} label="Type" fieldName="displayAddressType" />}
          placeholder="Type"
          selection
          search
          clearable
          options={workTypeOptions}
          allowAdditions
        />
      </div>
      <CustomTitleField index={index} />
    </div>
  );
};
export default AddressWidgetSettings;
